import React,{Fragment} from 'react';
import './index.scss';
import DataGrid, {
    Column,
    Paging,
} from 'devextreme-react/data-grid';
import {createStore} from "devextreme-aspnet-data-nojquery";
import url from '../../api/base-url';
import manualOrdersIcon from '../../assets/shipsland.png';
import ebayIcon from '../../assets/ebay_icon.png';
import etsyIcon from '../../assets/etsy_icon.png';
import shopifyIcon from '../../assets/shopify_icon.png';
import addressApi from '../../api/address';
import sessions from '../../sessions';

const Customers = () =>{
    const userId = sessions.getSession("user")?.id;
    const auth = sessions.getSession("user")?.accessToken;
    function getConfig(options) {  
        options.onBeforeSend = function(method, ajaxOptions) {  
            ajaxOptions.headers = {  
               "x-access-token": auth
            }  
        }  
        return options;  
    };

    const customersDataSource = createStore(getConfig({
            key: '_id', 
            loadUrl: `${url}/customers/${userId}`
    }));

    const dateOptions = {
        useMaskBehavior: true,
        type: "date",
        displayFormat: "shortdate"
    }

    const nameOptions = {
        width: '100px'
    }

    const capitalize = (s) => {
        return s?s
            .toLowerCase()
            .replace(/\b./g, function (a) {
                return a.toUpperCase();
            }):'';
    };

    const countryRender = ({value}) => {
        console.log("country-render", value);
        const country = addressApi.getCountryByIso2(value);
        return (<span> {country?.name} </span>)
        
    }

    
    const storeNameRender = (data) => {
        const value = data.data;
        var store = value.store;
        var storeName = value.storeName?value.storeName:value.store;
        if(store.includes('Manual Orders')){
            return ( <span className={'store'}><img alt="Manual Orders" className={'store-icon'} src={manualOrdersIcon}/> {capitalize(storeName)} </span>) 
        }
        else if(store.includes('ebay')){
            return ( <span className={'store'}><img alt="ebay" className={'store-icon'} src={ebayIcon}/> {capitalize(storeName)} </span>)
        }
        else if(store.includes('etsy')){
            return (<span className={'store'}><img alt="etsy" className={'store-icon'} src={etsyIcon}/> {capitalize(storeName)} </span>)
        }  
        else if(store.includes('shopify')){
            return (<span className={'store'}><img alt="shopify" className={'store-icon'} src={shopifyIcon}/> {capitalize(storeName)} </span>)
        }
        else
            return (<span> {capitalize(store)} </span>)
    }
return(
    <Fragment>
    <h4 className={'content-block'}>Customers</h4>
    <div className={'content-block'}>
        <DataGrid dataSource={customersDataSource}
         showBorders={false}
         focusedRowEnabled={true}
         allowColumnReordering={true}
         allowColumnResizing={true}
         columnAutoWidth={true}
         columnHidingEnabled={true}
        >
            <Paging defaultPageSize={10}/>
            <Column dataField={'name'} />
            <Column dataField={'city'} />
            <Column dataField={'state'}/>
            <Column dataField={'country'} cellRender={countryRender}/>
            <Column dataField={'store'} cellRender={storeNameRender}/>
            <Column dataField={'email'} />
            <Column dataField={'phone'} />
            <Column dataField={'company'} />
        </DataGrid>
    </div>
</Fragment>
)
};
export default Customers;